// Lucide icon: banknote (https://lucide.dev/icons/banknote)
import { Banknote } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCash = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Banknote />
    </IconComponentStyled>
  )
}
